// removed by extract-text-webpack-plugin
module.exports = {"horizontal":"theme__horizontal___37DOH","vertical":"theme__vertical___2J0DT"};


//////////////////
// WEBPACK FOOTER
// ./~/@luminopia/react-toolbox/lib/navigation/theme.css
// module id = 1196
// module chunks = 0